import React, { Component } from 'react';
import Header from '../HeaderSection/Header';
import FooterSection from "../FooterSection/Footer";
import Breadcrumb from '../Blogs/Breadcrumb';

class PrivacyPolicy extends Component {
  state = {
    initData: []
  }

  render() {
    return (
      <div>
        {/*====== Scroll To Top Area Start ======*/}
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        {/*====== Scroll To Top Area End ======*/}
        <div className="main">
          <h3 className="nav-link" style={{ marginTop: '20px' }}>Guess Who Never - Privacy Policy</h3>
          <h5 className="nav-link" style={{ marginTop: '20px' }}>Effective Date: April 30, 2025</h5>

          <h5 className="nav-link">Article 1: Purpose of this Privacy Policy</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            This Privacy Policy outlines how the personal data of users ("Users") of the *Guess Who Never* mobile application ("the Application") is collected, used, stored, and shared.
            By using the Application, Users agree to this Privacy Policy and related documents made available within the app. “Personal data” refers to any information that can directly or indirectly identify an individual.
          </p>

          <h5 className="nav-link">Article 2: Data Collection and Use</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            While using *Guess Who Never*, the following data may be collected to ensure functionality and improve the experience:
            <ul>
              <li>An anonymous ID to enable subscription verification.</li>
              <li>Player names and avatars set during gameplay (stored locally only).</li>
              <li>Device metadata such as language, OS, and country.</li>
              <li>In-game behavior (e.g., number of rounds, interaction times) for analytics.</li>
            </ul>
            *Guess Who Never* does not collect names, emails, phone numbers, or precise location. All collected data is used solely for enhancing gameplay and is erased when the app is uninstalled.
          </p>

          <h5 className="nav-link">Article 3: Children’s Privacy</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            This game is intended for users aged 17+. If it’s discovered that data was collected from users under 17, it will be deleted. Parents or guardians may contact: moussa@furrbud.com.
          </p>

          <h5 className="nav-link">Article 4: Data Storage</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            Data is stored on secure Firebase servers. Usernames and avatars are kept only on the local device and cleared when the app is deleted.
            Subscription verifications via platform ID are not permanently stored.
          </p>

          <h5 className="nav-link">Article 5: Data Transfers</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            We do not share personal data with third parties unless required by law or platform terms (e.g., App Store, Google Play). Payments and subscriptions are managed by these stores.
          </p>

          <h5 className="nav-link">Article 6: User Rights</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            To request data deletion or changes, contact: moussa@furrbud.com. Any local data is also automatically deleted upon uninstalling the app.
          </p>

          <h5 className="nav-link">Article 7: Changes to This Policy</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            We may update this policy without notice. The latest version will always be accessible within the app.
          </p>

          <h5 className="nav-link">8. Contact Us</h5>
          <h5 className="nav-link">Guess Who Never - FurrBud</h5>
          <h5 className="nav-link">Last updated: April 30, 2025</h5>
          <h5 className="nav-link">moussa@furrbud.com</h5>
          <h5 className="nav-link">+96178912776</h5>
          <h5 className="nav-link">Thank you for playing Guess Who Never!</h5>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicy;
